// TODO: remove after idp auth release
function _getCookie(name) {
  if (typeof document === 'undefined') return null;
  // eslint-disable-next-line
  var matches = document.cookie.match(new RegExp("(?:^|; )".concat(name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1'), "=([^;]*)")));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

// TODO: remove after idp auth release
export { _getCookie as getCookie };
export function setCookie(_ref) {
  var name = _ref.name,
    value = _ref.value,
    domain = _ref.domain,
    ttl = _ref.ttl,
    path = _ref.path;
  if (typeof document !== 'undefined') {
    // eslint-disable-next-line max-len
    document.cookie = "".concat(name, "=").concat(value).concat(domain ? ";domain=".concat(domain) : '').concat(path ? ';path=/' : '').concat(ttl ? ";expires=".concat(new Date(new Date().getTime() + ttl).toUTCString()) : '');
  }
}

// TODO: remove after idp auth release
export function deleteCookie(name, path) {
  if (typeof document !== 'undefined') {
    document.cookie = "".concat(name, "=; Path=").concat(path && '/', "; Expires=Thu, 01 Jan 1970 00:00:01 GMT;");
  }
}
export var cookiesDeviceService = {
  getCookie: function getCookie(name) {
    var cookie = [];
    try {
      cookie = JSON.parse(_getCookie(name)) || [];
    } catch (e) {
      // no action on error
    }
    return cookie;
  },
  addDevice: function addDevice(type, deviceId) {
    var deviceList = [];
    try {
      deviceList = JSON.parse(_getCookie(type)) || [];
    } catch (e) {
      // no action on error
    }
    if (!deviceList.includes(deviceId)) {
      deviceList.push(deviceId);
    }
    setCookie({
      name: type,
      value: JSON.stringify(deviceList),
      path: true
    });
    return deviceList;
  },
  deleteDevice: function deleteDevice(type, deviceId) {
    var deviceList = [];
    try {
      deviceList = JSON.parse(_getCookie(type)) || [];
    } catch (e) {
      // no action on error
    }
    var newList = deviceList.filter(function (item) {
      return item !== deviceId;
    });
    setCookie({
      name: type,
      value: JSON.stringify(newList),
      path: true
    });
    return newList;
  }
};
export var getRootCookieDomain = function getRootCookieDomain() {
  if (/beelinetst/.test(window.location.hostname)) {
    return '.beelinetst.ru';
  }
  if (/vimpelcom/.test(window.location.hostname)) {
    return '.vimpelcom.ru';
  }
  if (/localhost/.test(window.location.hostname)) {
    return '';
  }
  return '.beeline.ru';
};